import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useWallet } from '../context/WalletContext';
import { useUserData } from '../hooks/useUserData';
import ReferralLink from '../components/team/ReferralLink';
import DirectReferrals from '../components/team/DirectReferrals';
import MatrixLevelsView from '../components/matrix/MatrixLevelsView';
import PackageSelector from '../components/matrix/PackageSelector';
import ConnectButton from '../components/common/ConnectButton';
import Loader from '../components/common/Loader';

const Team = () => {
  const { connected } = useWallet();
  const { userId, user, initialLoading, isRegistered } = useUserData();
  const [selectedPkg, setSelectedPkg] = useState(1);

  if (!connected) {
    return (
      <div className="main-content">
        <div className="connect-prompt">
          <div className="connect-prompt-icon">🔗</div>
          <h2>Connect Your Wallet</h2>
          <div className="mt-lg"><ConnectButton /></div>
        </div>
      </div>
    );
  }

  if (initialLoading) return <Loader text="Loading Team" />;
  if (!isRegistered) return <Navigate to="/register" replace />;

  const topPkg = user?.topPackageId || 0;

  return (
    <div className="main-content">
      <div className="page-header">
        <h1 className="page-title">Team</h1>
        <p className="page-subtitle">Your referral network & matrix</p>
      </div>

      <div className="mb-lg">
        <ReferralLink userId={userId} />
      </div>

      {topPkg > 0 && (
        <>
          <div className="section-heading">
            <span className="section-heading-bar"></span>
            Matrix Levels
          </div>
          <div className="mb-md text-muted" style={{ fontSize: 13 }}>
            Choose a package to view its matrix. Tap any level to see members.
          </div>
          <div className="mb-md">
            <PackageSelector
              selected={selectedPkg}
              onChange={setSelectedPkg}
              maxPackage={topPkg}
            />
          </div>
          <MatrixLevelsView userId={userId} packageId={selectedPkg} />
        </>
      )}

      <div className="section-heading">
        <span className="section-heading-bar"></span>
        Direct Referrals
      </div>
      <DirectReferrals userId={userId} />
    </div>
  );
};

export default Team;
